import _taggedTemplateLiteral from "@babel/runtime/helpers/taggedTemplateLiteral";

var _templateObject;

import { font, spacing } from '@chegg-ui/theme';
import { getMediaQueryV2 } from '@chegg-me-lpc/utils';
import styled from 'styled-components';
export var FooterShell = styled.footer.withConfig({
  componentId: "sc-108l2ny-0"
})(["display:flex;flex-direction:column;justify-content:center;align-items:center;font-family:", ";padding:0 ", ";", ""], font.family.aspira, spacing.px48, getMediaQueryV2.smAndLower(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n      padding: 0 ", ";\n  "])), spacing.px24));
export var LegalLinksContainer = styled.div.withConfig({
  componentId: "sc-108l2ny-1"
})(["width:100%;padding:", " 0;flex-grow:1;"], spacing.px12);
export var StorybookSignInFooterStyled = styled.div.withConfig({
  componentId: "sc-108l2ny-2"
})(["margin-top:100px;"]);